<template>
  <div id="Contact">
    <div class="banner">
      <img src="/static/images/contact/m_cs_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("contact.bannerText")}}</div>
        <div class="titleSub">{{$t("contact.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
            <div class="contactInfo">
              <div class="contactNumber">
                <div>
                  <div class="title">
                    {{$t("contact.contactNumber.tit")}}
                  </div>
                  <div class="tel">
                    {{$t("contact.contactNumber.cnTel")}}
                  </div>
                  <div class="tel">
                    {{$t("contact.contactNumber.EnTel")}}
                  </div>
                  <div class="serviceTime">
                    {{$t("contact.contactNumber.time")}}
                  </div>
                </div>
              </div>
              <div class="contactAddress">
                <div class="title">
                 {{$t("contact.contactAddress.tit")}}
                </div>
                <div class="address">
                  {{$t("contact.contactAddress.address1")}}
                </div>
                <div class="address">
                  {{$t("contact.contactAddress.address2")}}
                </div>
              </div>
              <div class="contactWechat">
                <div class="title">
                  {{$t("contact.contactWechat")}}
                </div>
                <div class="qrcode">
                  <img src="/static/images/common/qrcode.png" alt="">
                </div>
              </div>
            </div>
            <div class="contactUs">
                <div class="title">
                  {{$t("contact.contactUs.tit")}}
                </div>
                <div class="tips">
                  {{$t("contact.contactUs.tips")}}
                </div>
                <div class="inputBox">
                  <div class="first">
                    <el-input resize='none' v-model="name" placeholder="Your Name"></el-input>
                    <el-input resize='none' v-model="tel" placeholder="Your Moble"></el-input>
                    <el-input resize='none' v-model="shopName" placeholder="Your Shop Name"></el-input>
                  </div>
                  <div class="second">
                    <el-input resize='none' v-model="storType" placeholder="Your store type"></el-input>
                    <el-input resize='none' v-model="storeAddress" type="textarea" :rows="3" placeholder="Your Shop Address"></el-input>
                  </div>
                </div>
                <div  class="submitBtn">
                  <el-button round>{{$t("contact.contactUs.submitBtn")}}</el-button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name:'',
      tel:'',
      shopName:'',
      storType:'',
      storeAddress:''
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {

  }
};
</script>
<style lang="less" type="text/less">
  .el-input__inner{
    background: #f7f7f7;
    color: #999;
    padding: 4px 15px;
  }
  .el-textarea__inner{
    background: #f7f7f7;
    color: #999;
    -webkit-appearance: none;
    appearance: none;
  }
  .el-input__inner:focus{
    border-color: #27C2B4;
  }
  .el-textarea__inner:focus{
    border-color: #27C2B4;
  }
</style>
<style scoped lang="less" type="text/less">
#Contact{
  margin-top: 50px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 20%;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      padding: 0 10px;
      color: #fff;
      .title{
        font-size: 3rem;
        font-weight: bold;
        position: relative;
      }
      .titleSub{
        font-size: 1.6rem;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 3rem 0;
    .con{
      width: 80%;
      margin: 0 auto;
      .contactInfo{
        // display: flex;
        // justify-content: space-between;
        // align-items:flex-start;
        position: relative;
        &::before{
          content:'';
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #e2e2e2;
          position: absolute;
          bottom: 0;
        }
        .contactNumber{
          display: flex;
          justify-content: space-between;
          align-items:flex-start;
          .title{
            font-size: 2rem;
            color: #333;
            font-weight: bold;
          }
          .tel{
            font-size: 1.6rem;
            color: #FF9703;
            font-weight: bold;
            padding: 8px 0;
            &:nth-child(3){
              padding-top: 0;
            }
          }
          .serviceTime{
            font-size: 1.4rem;
            color: #666;
          }
        }
        .contactAddress{
          padding: 20px 0;
          .title{
            font-size: 2rem;
            color: #333;
            font-weight: bold;
          }
          .address{
            font-size: 1.4rem;
            color: #666;
            padding: 15px 0px;
            max-width: 500px;
            &:nth-child(3){
              padding-top: 0;
            }
          }
        }
        .contactWechat{
          .title{
            font-size: 2rem;
            color: #333;
            font-weight: bold;
          }
          .qrcode{
            padding: 15px 0;
            img{
              width: 100%;
              max-width: 90px;
            }
          }
        }
      }
      .contactUs{
        padding: 2rem 0;
        .title{
          color: #333;
          font-size: 2rem;
          font-weight: bold;
        }
        .tips{
          color: #666;
          font-size: 1.4rem;
          padding-top: 15px;
        }
        .inputBox{
          padding: 3rem 0;
          .first{
            .el-input{
              display: inline-block;
              &:nth-child(2){
                margin:10px 0;
              }
            }
          }
          .second{
            .el-input{
              &:nth-child(1){
                margin:10px 0;
              }
            }
          }
        }
          .submitBtn{
            text-align: center;
            button{
              background: #27C2B4;
              box-shadow:0px 3px 6px rgba(11,128,117,0.26);
              font-weight: bold;
              font-size: 16px;
              border-radius:38px;
              padding: 12px 35px;
              color: #fff;
              width: 100%;
              &:focus{
                border-color: #27C2B4;
              }
            }
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Contact/Contact.vue